import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import WistiaVideo from './Videos.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from "react-helmet";

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    fbButton: {
        backgroundColor: 'rgb(0, 167, 245)',
        borderRadius: '12px',
        color: 'white',
        fontSize: '22px',
        padding: '24px 0',
        width: '50%',
        marginTop: '10px',
    },
    levelListBox: {
        marginTop: '20px',
    }
}
class EditTiers extends Component{

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Online Paper Editor Service Options | Edit My Paper</title>
                    <meta property="og:title" content="Online Paper Editor Service Options | Edit My Paper" ></meta>
                    <meta name="description" content="These are examples of what you can generally expect from the editor level you select. Of course, your document is unique and will look substantially different."></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                    <link rel="canonical" href="https://editmypaper.ca/edit-tiers" />
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div className="steps-container">
                        <center>
                            <h1 style={styles.localH1}>What To Expect from Your Gold, Silver, or Bronze Level Paper Editor</h1>
                            <h2 style={styles.localH2}>Remember, we do more than just proofread - we edit your work until it reads perfectly!</h2>
                        </center>
                        <div style={styles.onlyParagraph}>
                            We are the only proofreading and editing service that will EDIT your paper to correct your: spelling, grammar, word choice, flow, consistency, run-on sentences, sentence fragments, and punctuation. 
                            Editors will also provide comments to guide you through any necessary improvements.
                        </div>
                        {/*
                        <center>
                            <a className="show-box-link" href="#">
                                <div style={styles.fbButton}>
                                    Click here to Like or Follow us for a free page!
                                </div>
                            </a>
                        </center>
                        */}
                        <div style={styles.levelListBox}>
                            <ul>
                                <li><LevelList level="gold"></LevelList></li>
                                <li><LevelList level="silver"></LevelList></li>
                                <li><LevelList level="bronze"></LevelList></li>
                            </ul>
                        </div>
                        <WistiaVideo></WistiaVideo>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}

export default connect(
  )(EditTiers);
  


// WEBPACK FOOTER //
// ./src/components/pages/EditTiers.js